import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Home from "../components/home"

const IndexPage = ({ data }) => {
  const { pageData } = data

  return (
    <Layout headerData={pageData.siteMetadata.pages.home} showHeader={false}>
      <SEO
        title={pageData.siteMetadata.pages.home.title}
        description={pageData.siteMetadata.pages.home.description}
        pathname="/"
        keywords={[
          "Rahul Vagadiya",
          "product engineer",
          "startup product development",
          "full-stack product engineer",
          "AI product development",
          "Dubai",
        ]}
      />
      <Home links={pageData.siteMetadata.dev.links} />
    </Layout>
  )
}

export const query = graphql`
  query HomeQuery {
    pageData: site {
      siteMetadata {
        pages {
          home {
            title
            name
            description
          }
        }
        dev {
          links {
            name
            url
            filename
            tooltip
            icon
          }
        }
      }
    }
  }
`

export default IndexPage
